// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customPosButton {
  text-align: center;
  cursor: pointer;
  padding: var(--padding, 0.5rem);
  min-width: max-content;
}

.customPosButtonText {
  font-weight: 700;
  line-height: 1;
  display: flex;
  align-items: center;
}

.customPosButton.has-custom-hover:hover {
  background: var(--custom-hover-bg) !important;
  color: var(--custom-hover-color) !important;
  & .custom-pos-icon-container {
    color: var(--custom-hover-color) !important;
  }
}

.customPosButton.black-s:hover {
  background-color: var(--surface-g5) !important;
  color: var(--surface-white) !important;
  & .custom-pos-icon-container {
    color: var(--surface-white) !important;
  }
}

.customPosButton.blue-d:hover {
  background-color: var(--blue-b1) !important;
  color: var(--surface-white) !important;
}

.customPosButton.blue-s:hover {
  background-color: var(--blue-b1) !important;
  color: var(--surface-white) !important;
  & .custom-pos-icon-container {
    color: var(--surface-white) !important;
  }
}

.customPosButton.red-transparent:hover {
  background-color: var(--red-solid) !important;
  color: var(--surface-white) !important;
}

.customPosButton.white-h:hover {
  background-color: var(--surface-g4) !important;
}

.customPosButton.green-d:hover {
  background-color: var(--green-g0) !important;
}

.customPosButton.light-red:hover {
  border: none;
  background-color: #f97272 !important;
  color: white !important;
}

.customPosButtonContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.customPosButton.login-primary {
  transition:
    background 0.15s,
    opacity 0.15s;
}
.customPosButton.login-primary:hover {
  background-color: #7a8fd8 !important;
  opacity: 0.9;
}
.customPosButton.login-active:hover:not(:disabled) {
  background: #0b1b3a;
}
.customPosButtonContainer.corner-layout {
  justify-content: space-between;
  width: 100%;
}

.customPosButtonLeftIcon,
.customPosButtonRightIcon {
  line-height: 50%;
}

.customPosButton:disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/PosCustomButton/PosCustomButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,2CAA2C;EAC3C;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;;iBAEe;AACjB;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd","sourcesContent":[".customPosButton {\n  text-align: center;\n  cursor: pointer;\n  padding: var(--padding, 0.5rem);\n  min-width: max-content;\n}\n\n.customPosButtonText {\n  font-weight: 700;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n}\n\n.customPosButton.has-custom-hover:hover {\n  background: var(--custom-hover-bg) !important;\n  color: var(--custom-hover-color) !important;\n  & .custom-pos-icon-container {\n    color: var(--custom-hover-color) !important;\n  }\n}\n\n.customPosButton.black-s:hover {\n  background-color: var(--surface-g5) !important;\n  color: var(--surface-white) !important;\n  & .custom-pos-icon-container {\n    color: var(--surface-white) !important;\n  }\n}\n\n.customPosButton.blue-d:hover {\n  background-color: var(--blue-b1) !important;\n  color: var(--surface-white) !important;\n}\n\n.customPosButton.blue-s:hover {\n  background-color: var(--blue-b1) !important;\n  color: var(--surface-white) !important;\n  & .custom-pos-icon-container {\n    color: var(--surface-white) !important;\n  }\n}\n\n.customPosButton.red-transparent:hover {\n  background-color: var(--red-solid) !important;\n  color: var(--surface-white) !important;\n}\n\n.customPosButton.white-h:hover {\n  background-color: var(--surface-g4) !important;\n}\n\n.customPosButton.green-d:hover {\n  background-color: var(--green-g0) !important;\n}\n\n.customPosButton.light-red:hover {\n  border: none;\n  background-color: #f97272 !important;\n  color: white !important;\n}\n\n.customPosButtonContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.customPosButton.login-primary {\n  transition:\n    background 0.15s,\n    opacity 0.15s;\n}\n.customPosButton.login-primary:hover {\n  background-color: #7a8fd8 !important;\n  opacity: 0.9;\n}\n.customPosButton.login-active:hover:not(:disabled) {\n  background: #0b1b3a;\n}\n.customPosButtonContainer.corner-layout {\n  justify-content: space-between;\n  width: 100%;\n}\n\n.customPosButtonLeftIcon,\n.customPosButtonRightIcon {\n  line-height: 50%;\n}\n\n.customPosButton:disabled {\n  cursor: not-allowed !important;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
